import { Page } from '@/core/architecture'

import { MissionDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * MissionDetail Page
 * Implemented as a practical sample.
 */
export const MissionDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <MissionDetailTemplate state={state} {...actions} />
}
